import React from "react";
import BaseEdge, { roundTo } from "./BaseEdge";

export default function StraightEdge({
  edge,
  nodeById,
  edgeIndex,
  selectedIndex,
  onSelectEdge,
  onStartEdgeDrag,
  color,
  isHovered,
  onHoverEnter,
  onHoverLeave,
}) {
  const from = nodeById[edge.from];
  const to = nodeById[edge.to];
  if (!from || !to) return null;

  const src = {
    x: roundTo(from.x + from.width / 2),
    y: roundTo(from.y + from.height / 2),
  };

  const dst = {
    x: roundTo(to.x + to.width / 2),
    y: roundTo(to.y + to.height / 2),
  };

  const d = `M ${src.x} ${src.y} L ${dst.x} ${dst.y}`;

  const labelPos = {
    x: (src.x + dst.x) / 2,
    y: (src.y + dst.y) / 2 - 8,
  };

  return (
    <BaseEdge
      d={d}
      stroke={color}
      // NEW HOVER PROPS
      isHovered={isHovered}
      onHoverEnter={onHoverEnter}
      onHoverLeave={onHoverLeave}
      onSelect={() => onSelectEdge(edgeIndex)}
      onStartDrag={(e) =>
        onStartEdgeDrag(edgeIndex, {
          clientX: e.clientX,
          clientY: e.clientY,
        })
      }
      label={edge.label}
      labelPos={labelPos}
    />
  );
}
